export default "__VITE_PUBLIC_ASSET__522c07e1__"